import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Provider } from 'src/app/models/administration/provider';
import { User } from 'src/app/models/administration/user';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';
import { InputOrOutputInventory } from 'src/app/models/inventory/input-or-output-inventory';
import { ItemComboLength } from 'src/app/models/inventory/item-combo-length';
import { WorkOrder, enumWorkOrderStates } from 'src/app/models/maintenance/work-order';
import { NotificationsService } from 'src/app/services/notifications.service';
import { UtilsServiceService } from 'src/app/services/utils-service.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { HandlerItemsSource } from 'src/app/components/shared/handler-items/handler-items.component';
import { HttpService, MenuBreadCrumb, MessageService, SessionService, params} from 'brainloper-ui';

@Component({
    selector: 'app-outputs-details',
    templateUrl: './outputs-details.component.html',
    styleUrls: ['./outputs-details.component.scss'],
    standalone: false
})
export class OutputsDetailsComponent implements OnInit, OnDestroy {
  public HandlerItemsSource = HandlerItemsSource;
  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Almacén Salidas',
      router: '/almacen/salidas_inventario',
    },
    {
      name: 'Detalle',
      current: true,
    },
  ];

  private urlCrudHistorOutput: string = `${EndpointDictionary.InventoryOutputsHistory.CRUD_INVENT_OUTPUT_DATA}`;
  public urlGetItemsForOutputs: string = `${EndpointDictionary.Item.ITEM_COMBO_OUTPUT_WAREHOUSE}`;

  public resourcesRequest: Array<InputOrOutputInventory> = [];
  private packOffData: any = {};
  private notificationId: number
  public fromPackOff = false;
  public workOrder: WorkOrder = {};
  public workOrderState = enumWorkOrderStates.IN_EXECUTION;

  constructor(
    private message: MessageService,
    public dialog: MatDialog,
    public router: Router,
    public http: HttpService,
    private utils: UtilsServiceService,
    private session: SessionService,
    private notificationService: NotificationsService,
  ) {
    this.notificationId = this.session.getData('id_notificacion');
  }

  async ngOnInit() {
    await this.getResourcesPackOff();
  }

  ngOnDestroy() {
    this.session.setData('packOffData',null)
  }


  async itemLenght($event: ItemComboLength) {
    if ($event.length == 0) {
      await this.message
        .Warning('Advertencia', 'Bodega vacia', true, 'Crear Entrada')
        .then((x) => {
          if (x) {
            let url = this.utils.getQueryParams(
              `/almacen/entradas_inventario/detalle?warehouseId=${$event.warehouseId}`
            );
            this.router.navigate([`${url.url}`], {
              queryParams: url.params,
            });
          }
        });
    }
  }

  async saveOutput($event: HistoryInventory) {
    this.message.openLoading('Cargando', 'Guardando Salidas');
    if (
      this.packOffData &&
      this.packOffData[0].id &&
      this.packOffData[0].id > 0
    ) {
      $event.orderId = this.packOffData[0].id;
    } else {
      $event.orderId = $event.orderId ?? 0;
      $event.updateResources = true;
    }
    let res = await this.http.postDataBody<GenericResponse>(
      this.urlCrudHistorOutput,
      $event
    );
    if (res) {
      if (res.notification) {
        this.notificationService.emitUpdateNotificationsByNotifications(
          res.notification
        );
      }
      if (this.packOffData.length > 0) {
        try {
          this.workOrder = this.packOffData[0] as WorkOrder;
          let bodyUsers = this.packOffData[1] as User[] | Provider[];
          await this.notificationService.sendOrderRadyNotification(
            this.workOrder,
            bodyUsers,
            $event.items,
            this.notificationId
          );
          this.message.SuccessToast('Despachando Recursos');
        } catch (error) {
          this.message.Error('Error', error['message']);
        }
      }
      this.message.closeLoading();
      this.message.SuccessToast('Salidas Inventario guardadas correctamente');
      setTimeout(() => {
        this.router.navigate(['/almacen/salidas_inventario']);
      }, 500);
    }
  }

  async saveOutputInventoryEquipment($event: HistoryInventory) {
    console.log($event);
  }

  async getResourcesPackOff() {
    this.packOffData = this.session.getData('packOffData');
    if (this.packOffData && this.packOffData[2]) {
      this.workOrderState = enumWorkOrderStates.TO_DISPATCH;
      this.resourcesRequest = this
        .packOffData[2] as Array<InputOrOutputInventory>;
      this.fromPackOff = this.packOffData[3] as boolean;
      this.workOrder = this.packOffData[0];
    }
  }
}
